module.exports = __webpack_public_path__ + "static/media/profile.b5b0ba27.jpeg";